import { LogBoxActions, LogBoxActionTypes } from "./LogBox.actions";
import { initialState } from "redux/initialState";
import { LogBoxState } from "models";

export const logboxReducer = (state: LogBoxState = initialState.logbox, action: LogBoxActionTypes): LogBoxState => {
  switch (action.type) {
    case LogBoxActions.CloseNotification:
      return { ...state, snackbar: { ...state.snackbar, isOpen: false } };
    case LogBoxActions.AddToLogBox:
      const newLogItem = action.payload;
      const logs = [newLogItem, ...state.logs];
      const snackbar = {
        isOpen: true,
        text: newLogItem.text,
        severity: newLogItem.severity,
      };

      return { ...state, logs, snackbar };
    default:
      return state;
  }
};
